@if (commissioner.result$ | async; as result) {

    @if (result.error; as error) {
        <app-error-panel [error]="error" />
    }

    @if (result.value?.data; as commissionerData) {
        <app-header [breadcrumbs]="['Commissioners', commissionerData.name]" mainHeading="{{commissionerData.name}}"
                    [links]="['/commissioners', '/commissioners/' + commissionerData.id]">
            <h4 subHeading class="header-sub-heading">Reference: {{ commissionerData.reference }}</h4>
            <div providerBadge>
                @if (commissionerData.status) {
                    <cll-badge colour="primary">Active</cll-badge>
                } @else {
                    <cll-badge colour="error">Inactive</cll-badge>
                }
            </div>
                @if (user()?.permissions?.permission_name?.includes('Administrator')) {
                    <div headingButton>
                        <button class="add-button"
                                [cllMenuTriggerFor]="clientMore"
                                cll-icon-button>
                            <cll-icon type="outlined">more_vert</cll-icon>
                        </button>
                        <ng-template #clientMore>
                            @if (commissionerData.status) {
                                <cll-menu>
                                    <button cllMenuItem (click)="changeStatus(commissionerData, false)">
                                        <cll-icon type="outlined">toggle_off</cll-icon>
                                        Mark as inactive
                                    </button>
                                </cll-menu>
                            } @else {
                                <cll-menu>
                                    <button cllMenuItem (click)="changeStatus(commissionerData, true)">
                                        <cll-icon type="outlined">toggle_on</cll-icon>
                                        Mark as active
                                    </button>
                                </cll-menu>
                            }
                        </ng-template>
                    </div>
                }
        </app-header>

        <div class="commissioners-view-container">
            <div class="view-accordion">
                <cll-collapsible-card>
                    <cll-card-header>
                        <cll-icon cllCardIcon type="outlined">person</cll-icon>
                        <cll-card-title>General information</cll-card-title>
                        <cll-card-subtitle>Commissioner reference, Commissioner name
                        </cll-card-subtitle>
                    </cll-card-header>
                    <app-commissioner-general-information (editGeneralInformationEvent)="editGeneralInformation()"
                                                          [commissionerData]="commissionerData" />
                </cll-collapsible-card>

                <cll-collapsible-card>
                    <cll-card-header>
                        <cll-icon cllCardIcon type="outlined">account_circle</cll-icon>
                        <cll-card-title>Contact details</cll-card-title>
                        <cll-card-subtitle>Map, Address, Email, Telephone, Fax
                        </cll-card-subtitle>
                    </cll-card-header>
                    <app-commissioner-contact-address (editContactAddressDetailsEvent)="editContactAddress()"
                                                      [commissionerData]="commissionerData" />
                </cll-collapsible-card>

                <cll-collapsible-card>
                    <cll-card-header>
                        <cll-icon cllCardIcon type="outlined">schedule</cll-icon>
                        <cll-card-title>Working hours</cll-card-title>
                        <cll-card-subtitle>Hours {{ commissionerData.name }} is available
                        </cll-card-subtitle>
                    </cll-card-header>
                    <app-commissioner-working-hours (editWorkingHoursEvent)="editWorkingHours()"
                                                    [commissionerData]="commissionerData" />
                </cll-collapsible-card>
            </div>
            <div>
                <div class="tabs-container">
                    <cll-horizontal-tabs [appearance]="tabAppearance" [tabItems]="tabItems"
                                         [currentTabId]="currentTabId"
                                         (currentTabIdChange)="currentTabIdChange($event)" />

                    @if (this.isUsersTabOpen) {
                        <app-commissioner-users-tab
                            [commissionerData]="commissioner"
                            (addUserEvent)="addUserEvent($event)"
                            (removeUserEvent)="removeUserEvent($event)"
                            (editUserPositionEvent)="editCommissionerUser($event)"
                        />
                    }

                    @if (this.isPackagesTabOpen) {
                        <app-commissioner-packages-tab [commissionerData]="commissionerData" />
                    }

                    @if (this.isAuditTabOpen) {
                        <app-commissioner-audit-tab />
                    }
                </div>
            </div>


        </div>
    }
}
